import React, { useState, useEffect } from 'react';
import { apiCall, getUser } from '../lib/api.js';
import { CATEGORIES } from '../lib/scorecard-config.js';

const ATTR_MAP = {};
CATEGORIES.forEach(cat => cat.attributes.forEach(a => { ATTR_MAP[a.id] = a.label; }));

const STATUS_STYLES = {
  pending: { bg: 'bg-amber-50 text-amber-700 border-amber-200', label: 'Pending review' },
  accepted: { bg: 'bg-emerald-50 text-emerald-700 border-emerald-200', label: 'Accepted' },
  rejected: { bg: 'bg-red-50 text-red-700 border-red-200', label: 'Rejected' },
};

export default function MyAppealsPage() {
  const user = getUser();
  const [appeals, setAppeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiCall('/my/appeals')
      .then(d => setAppeals(d.appeals || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h2 className="text-lg font-medium mb-5">My appeals</h2>
      {loading ? (
        <div className="text-center py-12 text-gray-400">Loading...</div>
      ) : appeals.length === 0 ? (
        <div className="bg-white rounded-xl border border-gray-200 p-8 text-center">
          <i className="ti ti-message-circle text-3xl text-gray-300" aria-hidden="true"></i>
          <p className="text-gray-400 mt-2 text-sm">No appeals submitted yet.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {appeals.map(appeal => {
            const st = STATUS_STYLES[appeal.status] || STATUS_STYLES.pending;
            return (
              <div key={appeal.id} className="bg-white rounded-xl border border-gray-200 p-4">
                <div className="flex items-center justify-between mb-2">
                  <div className="text-sm font-medium">Ticket #{appeal.ticket_number} <span className="font-normal text-gray-500">{appeal.ticket_subject}</span></div>
                  <span className={'text-[11px] font-medium px-2.5 py-1 rounded-full border ' + st.bg}>{st.label}</span>
                </div>
                <div className="text-xs text-gray-400 mb-3">
                  Original score: {Math.round((appeal.original_score || 0) * 100)}% ({appeal.rating_band})
                  {appeal.new_final_score != null && appeal.status === 'accepted' && (
                    <span className="ml-2 text-emerald-600">→ Updated to {Math.round(appeal.new_final_score * 100)}%</span>
                  )}
                </div>
                {(appeal.appealed_attributes || []).map((attr, i) => (
                  <div key={i} className="bg-gray-50 rounded-lg p-3 mb-2 last:mb-0">
                    <div className="text-xs font-medium text-gray-700 mb-1">{ATTR_MAP[attr.id] || attr.id} — {attr.current_rating}</div>
                    <p className="text-xs text-gray-500">{attr.reason}</p>
                  </div>
                ))}
                {appeal.reject_reason && (
                  <div className="bg-red-50 rounded-lg p-3 mt-2">
                    <div className="text-xs font-medium text-red-700 mb-1">Rejection reason:</div>
                    <p className="text-xs text-red-600">{appeal.reject_reason}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
